import React from "react";
import "./container.css";

const EmbedContainer = ({ embedUrl, showCode, urlToShow }) => {
  return (
    <div className="container">
      <h3>Embed :</h3>
      <div
        className="container"
        style={{ maxWidth: "1024px", height: "768px", margin: "0 auto" }}
      >
        <iframe title="Insurgate" src={embedUrl} width="100%" height="100%" />
      </div>
      {showCode && (
        <div style={{ maxWidth: "1024px", margin: "0 auto" }}>
          <h3>Embed Code :</h3>
          <code>{`<iframe title="Insurgate" src="${urlToShow}" width="100%" height="100%" />`}</code>
        </div>
      )}
    </div>
  );
};

export default EmbedContainer;
